import { createFileRoute } from '@tanstack/react-router'

import { ConditionPhotos } from '@/features/condition/condition-photos'
import { handoverGate } from '@/features/handover/gate'

/** The four-panel capture for a booking's drive, at `/bookings/{id}/condition`, and the inspection a loan was closed without. */
export const Route = createFileRoute('/_app/bookings/$bookingId_/condition')({
  ...handoverGate(),
  component: ConditionPhotos,
})
